var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowershape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 722.058,
    height: 257.788,
    viewBox: "0 0 722.058 257.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}.a{fill:url(#a);}.b{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.134,
    y1: 0.774,
    x2: 0.948,
    y2: -0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b93a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dea2b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.596,
    y1: 0.961,
    x2: 0.362,
    y2: -0.38,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -608.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M720.5,154.79H0V0C63.86,48.7,124.905,71.383,192.114,71.383c10.41,0,20.911-.515,32.1-1.575,9.983-.945,20.291-2.3,31.513-4.157,20.862-3.442,41.859-8.12,62.164-12.644l.024-.005.912-.2c41.005-9.136,83.407-18.584,128.6-18.584A305.679,305.679,0,0,1,486.588,36.7c6.744.874,13.544,2,20.211,3.346,6.878,1.388,13.84,3.058,20.693,4.964,14.344,3.99,28.358,8.471,41.652,13.318,12.663,4.617,25.007,9.686,36.689,15.067,11.076,5.1,21.853,10.622,32.033,16.405,9.6,5.457,18.917,11.287,27.684,17.331a336.6,336.6,0,0,1,29.424,22.737A298.38,298.38,0,0,1,720.5,154.789Z",
    transform: "translate(-0.5 711.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M192.145,173.392a273.641,273.641,0,0,1-90.854-15.1c-8.03-2.776-16.161-5.995-24.167-9.567-8.252-3.682-16.626-7.854-24.89-12.4-8.5-4.674-17.139-9.885-25.684-15.489C17.784,115.087,8.852,108.75,0,102V.868C7.569.292,15.3,0,22.992,0c9.566,0,19.351.451,29.082,1.342,10.185.932,20.6,2.372,30.947,4.278,10.8,1.99,21.833,4.543,32.791,7.59,11.406,3.171,23.051,6.965,34.612,11.277a184.109,184.109,0,0,1,32.8,16.46c10.5,6.485,20.718,13.745,31.534,21.433,44.459,31.6,94.85,67.407,198.482,75.55-32.636,3.127-64.48,10.22-95.275,17.08h-.005l-.009,0c-20.316,4.525-41.323,9.2-62.185,12.646-11.229,1.852-21.537,3.212-31.515,4.156-11.194,1.06-21.7,1.575-32.1,1.575h0Z",
    transform: "translate(-0.5 609.22)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowershape);
export default __webpack_public_path__ + "static/media/lowershape.f5a0e90b5a7e9b66e7d1c871c753c825.svg";
export { ForwardRef as ReactComponent };